import React, { useState, useEffect, useRef, useCallback } from 'react';

export const PHYSICS = {
  GRAVITY: 12,
  AIR_DENSITY: 1.2,
  BASE_LIFT: 0.006,
  BASE_DRAG: 0.992,
  BOOST_FORCE: 45,
  STALL_SPEED: 8,
  TERMINAL_VELOCITY: 120,
  GROUND_LEVEL: 0,
};